module.exports = __webpack_public_path__ + "static/media/classroom_bottom_close_1.5a302283.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/classroom_bottom_close_1.png
// module id = 1971
// module chunks = 4